


































































import { Vue, Component, Watch } from "vue-property-decorator";
import { PrimaryAdminRoutes, SecondaryAdminRoutes } from "@/router/admin/menu";
import { UpmindModuleCodes } from "@/data/enums/upmindModules";
import { IMenuRoute } from "@/models/routes";
import { mapState } from "vuex";
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      injectedModules: ({ org }: IState) => org.injectedModules
    })
  }
})
export default class AdminNavigationBody extends Vue {
  // Data

  public injectedModules!: UpmindModuleCodes[];
  public injectedRoutes = [];

  // Computed

  public get primaryRoutes() {
    return this.$_.orderBy(
      this.$_.union(PrimaryAdminRoutes, this.injectedRoutes),
      ["order"],
      ["asc"]
    );
  }

  public get secondaryRoutes() {
    return this.$_.orderBy(SecondaryAdminRoutes, ["order"], ["asc"]);
  }

  public get vm() {
    return this;
  }

  // Methods

  public filterRoutes(routes) {
    return this.$_.filter(routes, route => {
      return this.$_.get(route, "if", () => true)(this);
    });
  }

  public navigateTo(e, navigate, item, route) {
    this.onClick(item, route);
    navigate(e);
  }

  public onClick(route, to) {
    const currentPath = this.$router.currentRoute.fullPath;
    if (currentPath === to.fullPath || this.$_.isEmpty(route.children)) {
      this.$store.commit("ui/openNav", false); // Close nav on mobile
    }
  }

  public itemIsActive(item, isActive) {
    return item.isActive
      ? item.isActive(this.$router.currentRoute, isActive)
      : isActive;
  }

  // Watchers

  @Watch("injectedModules", { immediate: true })
  public async onInjectedModuleChange(newValue, oldValue) {
    const newModules = this.$_.difference(newValue || [], oldValue || []);
    let injectedRoutes = [] as IMenuRoute[];
    for (const moduleCode of newModules as UpmindModuleCodes[]) {
      try {
        const moduleMenu = await import(`@/modules/${moduleCode}/router/menu`);
        const moduleRoutes = this.$_.get(
          moduleMenu,
          "AdminMenuRoutes",
          () => []
        )(this.vm);
        injectedRoutes = [...injectedRoutes, ...moduleRoutes];
      } catch (error) {
        // Silent fail
        // `modules/{moduleCode}/menu.ts` may be missing or no `AdminMenuRoutes` exported
      }
    }
    this.$set(this, "injectedRoutes", injectedRoutes);
  }
}
